module.exports = __webpack_public_path__ + "static/media/tier-9.69ed7759.jpg";